module.exports = __webpack_public_path__ + "static/media/sculpey.e7fb9f4a.png";